import { render, staticRenderFns } from "./IconClock.vue?vue&type=template&id=ec476cb8&scoped=true&"
import script from "./IconClock.vue?vue&type=script&lang=js&"
export * from "./IconClock.vue?vue&type=script&lang=js&"
import style0 from "./IconClock.vue?vue&type=style&index=0&id=ec476cb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec476cb8",
  null
  
)

export default component.exports